// Globals
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';

// Models
import { OrderCancellationReason } from '@/models/orders.model';

// Components
import { StyledSelect } from '../UpdateOrderPaymentModal/UpdateOrderPaymentModalStyles';

// Helpers
import { getCancellationReasonOptions } from '../../helpers';

interface CancellationReasonFieldsProps {
  reason?: OrderCancellationReason;
  reasonText?: string;
  onReasonChange: (reason?: OrderCancellationReason) => void;
  onReasonTextChange: (text: string) => void;
}

const CancellationReasonFields = ({
  reason,
  reasonText,
  onReasonChange,
  onReasonTextChange,
}: CancellationReasonFieldsProps) => {
  const { t } = useTranslation(['orders']);
  const options = getCancellationReasonOptions(t);

  const handleReasonChange = (value: unknown) => {
    const nextReason = (value as OrderCancellationReason) || undefined;
    onReasonChange(nextReason);

    if (nextReason !== OrderCancellationReason.OTHER) {
      onReasonTextChange('');
    }
  };

  return (
    <>
      <StyledSelect
        options={options}
        placeholder={t('cancellation_reason_select_placeholder')}
        onChange={handleReasonChange}
        value={reason}
        size="large"
        allowClear
      />
      {reason === OrderCancellationReason.OTHER && (
        <Input.TextArea
          rows={3}
          value={reasonText}
          onChange={(e) => onReasonTextChange(e.target.value)}
          placeholder={t('cancellation_reason_other_placeholder')}
          style={{ marginBottom: '1.5rem' }}
        />
      )}
    </>
  );
};

export default CancellationReasonFields;
